import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping } from '@cfg/pageRoutes.tsx';

const SiteSettingsPage = lazyWithRetry(() => import('@pages/dashboard/SiteSettingsPage.tsx'));

/**
 * Configuration routes for E-Shop dashboard and ERP contexts.
 * 
 * Note: Layout is handled by LayoutResolver based on path prefix:
 * - /dashboard/* routes get EshopDashboardLayout automatically
 * - /erp/* routes get the default ERP layout
 * 
 * No manual layout wrapping required here.
 */
const configurationRoutes: ComponentOrMapping = {
    dashboard: {
        eshop: {
            // E-Shop dashboard route - LayoutResolver applies EshopDashboardLayout automatically
            configuration: { component: SiteSettingsPage },
        },
    },
    erp: {
        configuration: {
            // ERP route - uses default ERP layout
            parameters: { component: SiteSettingsPage },
        },
    },
};

export default configurationRoutes;
